import { useEffect, useState, useRef } from 'react';
import { AntAPI, AntAuth } from 'ante-react-kit';

export default function useFilterSources({ enabled, session }) {
    const [sources, setSources] = useState({ tags: [], collections: [], loyaltyLevels: [] });
    const loaded = useRef(false);

    useEffect(() => {
        if (!enabled || loaded.current) return;
        loaded.current = true;

        const bus = (session && session.bus_settings) || AntAuth.getSessionInfo('bus_settings') || {};
        const user = (session && session.user_settings) || AntAuth.getSessionInfo('user_settings') || {};

        // Tags: lấy từ user setting AROrder_CustomerTags (CSV hoặc array)
        try {
            const raw = user.AROrder_CustomerTags;
            let tags = [];
            if (Array.isArray(raw)) tags = raw;
            else if (typeof raw === 'string' && raw) tags = raw.split(/[,;]/).map((s) => s.trim()).filter(Boolean);
            if (tags.length > 0) setSources((prev) => ({ ...prev, tags }));
        } catch (e) { /* ignore */ }

        // Collections: đọc từ BusinessEntity search/prepare -> lookups.entity_collections
        (async () => {
            try {
                const api = new AntAPI('entity', 'BusinessEntity');
                const res = await api.postSearchPrepare({}, { caching: false });
                const lk = (res && res.lookups && res.lookups.entity_collections) || [];
                const collections = lk.map((r) => ({
                    code: r.code || r.value || r,
                    name: r.name || r.label || r.code || r
                })).filter((c) => c.code);
                if (collections.length > 0) setSources((prev) => ({ ...prev, collections }));
            } catch (e) { /* ignore */ }
        })();

        // Loyalty levels: /crm/CRMLoyaltyLevel/list
        if (bus.use_Module_Loyalty || bus.use_Module_CRM) {
            (async () => {
                try {
                    const api = new AntAPI('crm', 'CRMLoyaltyLevel');
                    const res = await api.getList(
                        { is_active: 1, pageSize: 200, pageIndex: 0 },
                        null,
                        { byPassTotal: true }
                    );
                    const rows = (res && res.rows) || [];
                    const levels = rows.map((l) => ({ code: l.code, name: l.name })).filter((l) => l.code);
                    if (levels.length > 0) setSources((prev) => ({ ...prev, loyaltyLevels: levels }));
                } catch (e) { /* ignore */ }
            })();
        }
    }, [enabled, session]);

    return sources;
}
